export default __webpack_public_path__ + "static/media/인액터스.8cafe66b.svg";